import { type AnyAction } from 'redux';
import { SET_ENABLE_LINKIFY } from './editor-config-actions';

type State = any;

export default function editorConfig(state: State = null, { type, payload }: AnyAction): State {
  switch (type) {
    case SET_ENABLE_LINKIFY:
      return { ...state, enableLinkify: payload };

    default:
      return state;
  }
}
